import { Checkbox, Typography } from '@yimoka/antd';
import type { ComponentProps } from 'react';

import { useTranslation } from '@/locales/i18n';

const AGREEMENT_URL = import.meta.env.VITE_AGREEMENT_URL
  || 'https://huashi-ai.feishu.cn/wiki/HZwrwQCOVigI9MkQtQnc399GnDg';
const PRIVACY_URL = import.meta.env.VITE_PRIVACY_POLICY_URL
  || 'https://huashi-ai.feishu.cn/wiki/S45Bw2h7ki1QI0kMgEjc9EVQnGg';

export function AgreementText() {
  const { t } = useTranslation();

  return (
    <span>
      {t('Account:login.agreementPrefix')}
      <Typography.Link href={AGREEMENT_URL} rel="noopener noreferrer" target="_blank">
        {t('Account:login.userAgreement')}
      </Typography.Link>
      <Typography.Link href={PRIVACY_URL} rel="noopener noreferrer" target="_blank">
        {t('Account:login.privacyPolicy')}
      </Typography.Link>
    </span>
  );
}

export function AgreementCheckbox(props: ComponentProps<typeof Checkbox>) {
  return (
    <Checkbox {...props}>
      <AgreementText />
    </Checkbox>
  );
}

export default AgreementText;
